import { Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from './components/utils/ProtectedRoute';
import AdminRoute from './components/utils/AdminRoute';

import PageNotFound from './pages/PageNotFound';
import AdminPanel from './pages/AdminPanel';
import Dashboard from './pages/Dashboard';

import Login from './pages/Login';

export default function Router() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Route>

      <Route element={<AdminRoute />}>
        <Route path="/admin" element={<AdminPanel />}>
          <Route index element={<Navigate to="users" replace />} />
          <Route path="users" element={<AdminPanel />} />
          <Route path="users/:userId" element={<AdminPanel />} />
        </Route>
      </Route>

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
